import { createHashRouter } from "react-router-dom";
import Index from "../views/Index";
import Main from "../views/dashboards/Main";
import Login from "../views/auth/Login";
import Register from "../views/auth/Register";
import ForgotPassword from "../views/auth/ForgotPassword";
import Users from "../views/users/Users";
import DashboardLayout from "../views/layouts/DashboardLayout";
import ProtectedRoute from "./ProtectedRoute";
import PublicRoute from "./PublicRoute";
import CompanyProfile from "../views/settings/CompanyProfile";
import PlaceholderPage from "../views/placeholders/PlaceholderPage";
import UserProfile from "../views/profile/UserProfile";
import Quartos from "../views/settings/Quartos";
import Servicos from "../views/settings/Servicos";
import Bancos from "../views/settings/Bancos";
import Series from "../views/settings/Series";
import Clientes from "../views/comercial/Clientes";
import Documento from "../views/comercial/Documento";
import ConsultarDocumentos from "../views/comercial/ConsultarFactura";
import Despesas from "../views/comercial/Despesa";
import FluxoCaixa from "../views/relatorios/FluxoCaixa";
import SaftContabilidade from "../views/relatorios/SAFTC";
import ContaCorrente from "../views/relatorios/ContaCorrente";
import ProdutividadeUtilizadores from "../views/relatorios/ProdutividadeUser";
import FechoDiario from "../views/relatorios/FechoDiario";
import ClientesCheckIn from "../views/relatorios/CheckIn";
import RelatoriosPdf from "../views/relatorios/RelatoriosPdf";
import LicenseExpired from "../views/license/LicenseExpired";

const page = (title, section) => <PlaceholderPage title={title} section={section}/>;

const routes = createHashRouter([
    {
        path:"/",
        element:<Index/>
    },
    {
        element:<PublicRoute/>,
        children:[
            {
                path:"/login",
                element:<Login/>
            },
            {
                path:"/register",
                element:<Register/>
            },
            {
                path:"/forgot-password",
                element:<ForgotPassword/>
            }
        ]
    },
    {
        element:<ProtectedRoute/>,
        children:[
            {
                path:"/licenca-expirada",
                element:<LicenseExpired/>
            },
            {
                path:"/dashboard",
                element:<DashboardLayout/>,
                children:[
                    {
                        path:"main",
                        element:<Main/>
                    },
                    {
                        path:"users",
                        element:<Users/>
                    },
                    {
                        path:"settings/company",
                        element:<CompanyProfile/>
                    },
                    {
                        path:"profile",
                        element:<UserProfile/>
                    },
                    {
                        path:"settings/users",
                        element:<Users/>
                    },
                    {
                        path:"settings/bancos",
                        element:<Bancos/>
                    },
                    {
                        path:"settings/series",
                        element:<Series/>
                    },
                    {
                        path:"settings/servicos",
                        element:<Servicos/>
                    },
                    {
                        path:"settings/quartos",
                        element:<Quartos/>
                    },
                ]
            }
        ]
    },
    {
        element:<ProtectedRoute/>,
        children:[
            {
                path:"/comercial",
                element:<DashboardLayout/>,
                children:[
                    {
                        path:"clientes",
                        element:<Clientes/>
                    },
                    {
                        path:"documentos",
                        element:<Documento/>
                    },
                    {
                        path:"documentos-emitidos",
                        element:<Documento initialTab="emitidos"/>
                    },
                    {
                        path:"comercial/documentos-emitidos",
                        element:<Documento initialTab="emitidos"/>
                    },
                    {
                        path:"comercial/consultar-factura",
                        element:<ConsultarDocumentos/>
                    },
                    {
                        path:"comercial/registar-despesa",
                        element:<Despesas/>
                    }
                ]
            }
        ]
    },
    {
        element:<ProtectedRoute/>,
        children:[
            {
                path:"/relatorios",
                element:<DashboardLayout/>,
                children:[
                    {
                        path:"comercial/clientes",
                        element:page("Documentos", "Comercial")
                    },
                    {
                        path:"comercial/documentos-emitidos",
                        element:<Documento initialTab="emitidos"/>
                    },
                    {
                        path:"comercial/anular-factura",
                        element:page("Anular Factura", "Comercial")
                    },
                    {
                        path:"comercial/consultar-factura",
                        element:<ConsultarDocumentos/>
                    },
                    {
                        path:"comercial/registar-despesa",
                        element:<Despesas/>
                    },
                    {
                        path:"/relatorios/pdf",
                        element:<RelatoriosPdf/>
                    },
                    {
                        path:"/relatorios/fluxo-caixa",
                        element:<FluxoCaixa/>
                    },
                    {
                        path:"/relatorios/saft-contabilidade",
                        element:<SaftContabilidade/>
                    },
                    {
                        path:"/relatorios/conta-corrente",
                        element:<ContaCorrente/>
                    },
                    {
                        path:"/relatorios/produtividade",
                        element:<ProdutividadeUtilizadores/>
                    },
                    {
                        path:"/relatorios/fecho-diario",
                        element:<FechoDiario/>
                    },
                    {
                        path:"/relatorios/check-in",
                        element:<ClientesCheckIn/>
                    }
                ]
            }
        ]
    }
])

export default routes;
